<div class="page-content-no-header page-container page-narrow">
  <div class="center-align heading grey-font" i18n="SystemUnavailablePage.Notes(heading)@@system-unavailable">System unavailable</div>

  <div class="paragraph-section grey-font">
    <div class="center-align" i18n="SystemUnavailablePage.Notes@@the-system-is-down-for-maintenance">The system is down for maintenance</div>
  </div>
</div>
